import { StyledSeparator } from "@/mds/components/separator/separator.style";
import { type SeparatorProps } from "react-aria-components";

interface Props extends SeparatorProps {}

export const MDSSeparator: React.FC<Props> = ({ elementType = "div", ...props }) => (
  <StyledSeparator {...props} elementType={elementType} />
);
